
import api from '@/api/proxyWeb/modesLivraison'

export default {

    getAll({ commit }) {

        commit('setModesLivraison', [])
        
        return api.list()
            .then(modesLivraison => {
                commit('setModesLivraison', modesLivraison)
            })
    }    
}